/* 布局 */
//前台
import Layout from "@views/layout";

const plawarehousegoodsRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plawarehousegoods/list",
        name: "PLAWAREHOUSEGOODS",
        meta: {
            title: "仓库商品管理",
        },
        component: () => import("@views/business/plawarehousegoods/index.vue"),
    },
        ],
};

export default plawarehousegoodsRouter;
